/**
 * Display helpers for the jewelry product configuration rows
 * (metal type / diamond quality / carat weight).
 */

/** "LG VS GH" -> "Lab Grown VS GH", "Nat SI" -> "Natural SI". */
export const formatDiamondQuality = (q?: string) =>
  q?.replace(/\bNat\b/gi, "Natural").replace(/\bLG\b/gi, "Lab Grown") ?? "";

/** "1.50" -> "1.50 ct". Already-suffixed values are left alone. */
export const formatCaratWeight = (c?: string | number) => {
  if (c === undefined || c === null || c === "") return "";
  const value = String(c).trim();
  return /\bct\b/i.test(value) ? value : `${value} ct`;
};

/**
 * Collapse a config key/label to a comparable form, so "Carat Weight",
 * "carat_weight" and "caratweight" all match. CAD BOM keys arrive in any of
 * these shapes.
 */
export const normalizeConfigKey = (label: string) =>
  label.toLowerCase().replace(/[\s_-]/g, "");

const normalize = normalizeConfigKey;

/** Display order requested for the share / submitted-order views. */
const CONFIG_ORDER = ["metaltype", "diamondquality", "caratweight"];

/** Rank for sorting; unlisted labels keep their original order after the listed ones. */
export const configOrderIndex = (label: string) => {
  const index = CONFIG_ORDER.indexOf(normalize(label));
  return index === -1 ? CONFIG_ORDER.length : index;
};

/** Apply the label-specific value formatting (carat suffix, LG/Nat expansion). */
export const formatConfigValue = (label: string, value: string) => {
  switch (normalize(label)) {
    case "caratweight":
      return formatCaratWeight(value);
    case "diamond":
    case "diamondquality":
      return formatDiamondQuality(value);
    default:
      return value;
  }
};
